import { z } from "zod";

export const subscribeWebpushValidation = z
  .object({
    action: z.enum(["fetch", "subscribe", "unsubscribe"]),
    subscription: z.object({
      endpoint: z.string().nullish(),
      expirationTime: z.number().nullish(),
      keys: z.record(z.string(), z.string()).nullish(),
    }),
  })
  .strict()
  .transform((results) => results)
  .pipe(
    z
      .object({
        action: z.enum(["fetch", "subscribe", "unsubscribe"]),
        subscription: z.object({
          endpoint: z.string().min(1).max(9999),
          expirationTime: z.number().int().positive().nullish(),
          keys: z.object({
            p256dh: z.string().min(1).max(9999),
            auth: z.string().min(1).max(9999),
          }),
        }),
      })
      .strict()
  );
